// 沟通管理Api
import request from '@/utils/request';
import { sift_query_list } from '@/utils/sift';

// 分页查询沟通信息列表
export function iagetTableColumn(data) {
    return request({
        url: `/ia/tableColumn/queryPageList.json`,
        method: 'post',
        data: sift_query_list(data),
        contentType: 'formData'
    })
}


// 新增列
export function iagetTableiaColumnAdd(data) {
    return request({
        url: `/ia/tableColumn/add`,
        method: 'post',
        data: sift_query_list(data),
        contentType: 'formData'
    })
}

// 修改列
export function iageTadjustUpdate(data) {
    return request({
        url: `/ia/tableColumn/update`,
        method: 'post',
        data: sift_query_list(data),
        contentType: 'formData'
    })
}


// 查询列列表
export function iageTadjustqueryList(data) {
    return request({
        url: `/ia/tableColumn/queryList.json`,
        method: 'post',
        data: sift_query_list(data),
        contentType: 'formData'
    })
}

// 根据ID查询列
export function iageTadjustRowApi(columnId) {
    return request({
        url: `/ia/tableColumn/queryById/${columnId}`,
        method: 'post',
        contentType: 'formData'
    })
}

// 级联数据导入
export function geImportOption(data) {
    return request({
        url: `/ia/tableColumn/importOption.json`,
        method: 'post',
        data: data
    })
}

// 上下移动修改
export function geTadMoverOrder(data) {
    return request({
        url: `/ia/tableColumn/adjustOrder`,
        method: 'post',
        data: sift_query_list(data),
        contentType: 'formData'
    })
}

// 拖拽排序
export function geImportIaDragOrder(data) {
    return request({
        url: `/ia/tableColumn/adjustDragOrder`,
        method: 'post',
        data: sift_query_list(data),
    })
}